module.exports = __webpack_public_path__ + "img/ch49.38fb7a61.jpg";